<mat-toolbar class="content-header">
    <h1 class="page-title">
        <mat-icon>category</mat-icon>
        {{'settings.project.models' | translate}}
        <!-- <app-help [link]="helpLink" class="helper-margin"></app-help> -->
    </h1>

    <span class="toolbar-spacer"></span>
</mat-toolbar>

<div class="model-list">
    <!-- <div class="model-element"> -->
    <mat-card class="model-upload-card">
        <app-file-input [accept]="accept" [noPreview]="true" (change)="loadModel($event)" class="model-image"></app-file-input>

        <div *ngIf="uploadInProgress">
            <mat-progress-bar mode="determinate" value="{{ uploadProgress }}"></mat-progress-bar>
        </div>

        <p *ngIf="uploadError" class="upload-error" [title]="uploadError">{{ uploadError }}</p>
    </mat-card>

    <!-- </div> -->
    <mat-card *ngFor="let model of models" class="model-element">
        <div *ngIf="isTranslating(model)" class="model-image model-placeholder">
            <span>{{ 'settings.project.model_translating' | translate }}</span>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>

        <div *ngIf="model.status === 'failed'" class="model-image model-placeholder model-failed">
            <mat-icon>error_outline</mat-icon>
            <span>{{ 'settings.project.model_failed' | translate }}</span>
            <small *ngIf="model.error_message">{{ model.error_message }}</small>
        </div>

        <img *ngIf="!isTranslating(model) && model.status !== 'failed'" mat-card-image [src]="model.thumbnail"
            class="model-image" />

        <mat-card-content>
            <p>{{ model.name }}</p>
            <span>{{ "datatable.status" | translate }} : {{ model.status }}</span>
        </mat-card-content>

        <mat-card-actions>
            <lib-button [text]="'form.edit' | translate" [size]="'small'" (click)="editModel(model)">
            </lib-button>

            <lib-button [text]="'form.delete' | translate" [size]="'small'" [color]="'warning'"
                (click)="deleteModel(model)">
            </lib-button>
        </mat-card-actions>
    </mat-card>
</div>